/**
 * Pokud bude formulář označen atributem data-s-pform="*", tak se takový formulář při změně uloží
 * a po příchodu zpět na něj zase znovu načte
 *
 * Reset se pak provádí nastavením atributu data-s-pform-reset="*,*" kde hvězdičky jsou hodnoty z
 * data-s-pform použitých jinde a oddelených čárkami.
 */


const ATTRIBUTE_KEY = 'data-s-pform';
const RESET_ATTRIBUTE_KEY = 'data-s-pform-reset';

export function initialize()
{
    resetStorage();
    populateForms();

    document.addEventListener('change', function(event) {
        if(event.target.closest('['+ATTRIBUTE_KEY+']')) {
            saveForms();
        }
    });
}

function resetStorage()
{
    document.querySelectorAll('['+RESET_ATTRIBUTE_KEY+']').forEach(function(element) {
        let keys = element.getAttribute(RESET_ATTRIBUTE_KEY).split(',');
        keys.forEach(function(key) {
            localStorage.removeItem(key);
        });
    });
}

function getForms()
{
    return document.querySelectorAll('['+ATTRIBUTE_KEY+']');
}

function getFormKey(form: HTMLFormElement)
{
    return form.getAttribute(ATTRIBUTE_KEY);
}

function saveForms()
{
    console.log('SAVE FORMS');
    getForms().forEach(function(form) {
        let activeForm = form as HTMLFormElement;
        let formIdentifier = getFormKey(activeForm);
        console.log('save form', formIdentifier, getFormData(activeForm));
        localStorage.setItem(formIdentifier, JSON.stringify(getFormData(activeForm)));
    });
}

function populateForms()
{
    console.log('POPULATE FORM');
    getForms().forEach(function(form) {
        let activeForm = form as HTMLFormElement;
        let formIdentifier = getFormKey(activeForm);
        const formElements = activeForm.elements;
        if (localStorage.key(formIdentifier)) {
            const savedData = JSON.parse(localStorage.getItem(formIdentifier)); // get and parse the saved data from localStorage
            if(savedData) {
                for (const element of formElements) {
                    if (element.name in savedData) {
                        let val = savedData[element.name];
                        if (element.type === 'checkbox' || element.type === 'radio') {
                            if(element.checked !== val) {
                                element.click();
                            }
                            //element.checked = val;
                        } else {
                            element.value = val;
                        }
                    }
                }
            }
        }
    })
}

function getFormData(form: HTMLFormElement) {
    const formElements = form.elements;
    let data = {};
    for (const element of formElements) {
        if (element.name.length > 0) {
            let val = element.value;
            if (element.type === 'checkbox' || element.type === 'radio') {
                val = element.checked;
            }

            data[element.name] = val;
        }
    }
    return data;
}
